import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Loader2 } from 'lucide-react';
import { useBrand } from '@/lib/brand';

function Logout() {
  const navigate = useNavigate();
  const brand = useBrand();
  
  useEffect(() => {
    // Clear all local storage data
    localStorage.clear();
    
    // Redirect to login page after a short delay
    const timer = setTimeout(() => {
      window.location.href = '/login';
    }, 1000);
    
    // Clean up timer if component unmounts
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-gradient-to-b from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-950">
      <div className="w-full max-w-md p-8 space-y-6 text-center">
        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-slate-100 dark:bg-slate-800">
          <LogOut className="w-8 h-8 text-primary" />
        </div>
        
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-white">Logging you out</h1>
        
        <p className="text-slate-600 dark:text-slate-400">
          You'll be redirected to the login page shortly.
        </p>
        
        <div className="flex items-center justify-center mt-6">
          <Loader2 className="w-6 h-6 text-primary animate-spin" />
        </div>
      </div>
      
      <div className="absolute bottom-6 text-sm text-slate-500 dark:text-slate-600">
        <p>Thank you for using {brand.name}</p>
      </div>
    </div>
  );
}

export default Logout;